import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    },
    setMergingPatientGridOpen(state) {
        state.mergingPatientGridIsOpen = true;
        state.patientGridIsOpen = false;
    },
    setMergingPatientGridClose(state) {
        state.mergingPatientGridIsOpen = false;
        state.patientGridIsOpen = true;
    }
}
